/* Scroll-dybde til dashboardets trafik-pixel.
   Publicerer 'piccolo_scroll' ved 25/50/75/100 % én gang pr. side.
   Pixelen (Kundebegivenheder) lytter kun med analytics-samtykke, så
   intet sendes for besøgende der har afvist cookies. */
(function () {
  var sa = window.Shopify && window.Shopify.analytics;
  if (!sa || typeof sa.publish !== 'function') return;
  var milepaele = [25, 50, 75, 100];
  var sendt = {};
  var timer = null;

  function tjek() {
    var doc = document.documentElement;
    var max = doc.scrollHeight - window.innerHeight;
    if (max <= 0) return;
    var procent = Math.round((window.scrollY || doc.scrollTop) / max * 100);
    for (var i = 0; i < milepaele.length; i++) {
      var m = milepaele[i];
      if (procent >= m - 2 && !sendt[m]) {
        sendt[m] = true;
        try { sa.publish('piccolo_scroll', { dybde: m }); } catch (e) {}
      }
    }
  }

  window.addEventListener('scroll', function () {
    if (timer) clearTimeout(timer);
    timer = setTimeout(tjek, 250);
  }, { passive: true });
})();
